// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_16P2X","large":"_2r8YZ","vertical":"cq2G3","bullet":"WE_YH","a11y":"zQ9Rh","a11Y":"zQ9Rh"};